function looksLikeHtml(value: string): boolean {
  return /<[a-z][\s\S]*>/i.test(value) || /&lt;[a-z]/i.test(value);
}

function decodeHtmlEntities(value: string): string {
  if (!value || !/&(?:#\d+|#x[\da-f]+|\w+);/i.test(value)) {
    return value;
  }
  if (typeof document !== "undefined") {
    const el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value;
  }
  return value
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&amp;/g, "&")
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

function extractRichTextFromObject(value: Record<string, unknown>): string {
  const preferredKeys = ["html", "content", "body", "value", "text", "markup", "richtext"];
  for (const key of preferredKeys) {
    const candidate = value[key];
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate;
    }
  }
  const strings = Object.values(value).filter(
    (entry): entry is string => typeof entry === "string" && entry.trim().length > 0
  );
  if (strings.length === 1) {
    return strings[0];
  }
  const htmlish = strings.filter(looksLikeHtml);
  if (htmlish.length) {
    return htmlish.join("\n");
  }
  return "";
}

export function coerceRichTextValue(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string") return decodeHtmlEntities(value);
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (Array.isArray(value)) {
    return value.map(coerceRichTextValue).filter(Boolean).join("\n");
  }
  if (typeof value === "object") {
    return decodeHtmlEntities(extractRichTextFromObject(value as Record<string, unknown>));
  }
  return "";
}
